import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import { Box, Stack, Typography } from "@mui/material";
import ReactPlayer from "react-player";
import { fetchAPI } from "../utils/fetchAPI";
import Loader from "./Loader";
import {Video} from './'
import { CheckCircle } from "@mui/icons-material";
import { Link } from "react-router-dom";

const VideoDetail = () => {
  const { id } = useParams();
  const [videos, setVideos] = useState(null)
  const [videoDetail, setVideoDetail] = useState(null);

  // fetch video and related video
  useEffect(() => {
    const fetchVideoDetail = async (id) => {
      const data = await fetchAPI(`videos?part=snippet,statistics&id=${id}`);

      setVideoDetail(data);
    };

    const fetchRelatedVideo = async (id) => {
      const data = await fetchAPI(`search?part=snippet&relatedToVideoId=${id}&type=video&maxResults=8`)
      
      setVideos(data);
      
    };

    fetchVideoDetail(id);
    fetchRelatedVideo(id);
  }, [id]);

  if (!videoDetail) return <Loader />;

  const data = videoDetail.items[0];

  console.log(videos);

  // Destructure the video detail
  const {
    snippet: { title, channelTitle, channelId },
    statistics: { viewCount, likeCount },
  } = data;
  
  return (
    <Box sx={{  zIndex: "-1"}}>
      <Stack
        direction={{ xs: "column", md: "row" }}
        sx={{
        }}
      >
        <Box flex={1}>
          <Box sx={{width: "100%", position: "sticky", top: "86px", height: 'auto'}}>
            <ReactPlayer
              url={`https://www.youtube.com/watch?v=${id}`}
              className="react-player"
              controls
            />
            <Typography
              p={2}
              sx={{ color: "#850E35" }}
              variant="h4"
              gutterBottom
              fontWeight="bold"
            >
              {title || "Demo Title"}
            </Typography>
            <Stack p={2} gap={2} direction="column" sx={{ color: "#EE6983" }}>
              <Link to={`/channel/${channelId}`}>
                <Typography sx={{ color: "##EE6983" }} variant="body2">
      
                  {channelTitle || "Demo Channel"}
                  <CheckCircle sx={{ fontSize: "16px", ml: "12px" }} />
                </Typography>
              </Link>
              <Stack direction="row" gap={2}>
                <Typography color="#EE6983">
                  {parseInt(viewCount).toLocaleString()}{" "}
                  <span>views</span>
                </Typography>
                <Typography>
                  {parseInt(likeCount).toLocaleString()} likes
                </Typography>
              </Stack>
            </Stack>
          </Box>
        </Box>
        <Box p={3} sx={{'overflowY': 'scroll', 'justifyContent' : 'center', 'alignItems' : 'center'}}>
          <Video videos={videos} direction="column"/>
        </Box>
      </Stack>
    </Box>
  );
};

export default VideoDetail;
